/**
 @author xiaoye
 @date 2020/4/22 4:01 下午
 */
import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;

//获取数据库表的字段类型
let token01 = null;
export const GetColumnByDataSetID = async (data) => {
    if (token01) {
        token01.cancel({status: 'cancel'});
    }
    token01 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/GetColumnByDataSetID?" + qs.stringify(data),
        method: "get",
        token: token01.token,
    })
};


//获取数据库表的字段类型
let token02 = null;
export const GetValuesByStringField = async (data) => {
    if (token02) {
        token02.cancel({status: 'cancel'});
    }
    token02 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/GetValuesByStringField?" + qs.stringify(data),
        method: "get",
        token: token02.token,
    })
};

//获取数字类型字段的最大值最小值
let token03 = null;
export const GetValuesByNumberField = async (data) => {
    if (token03) {
        token03.cancel({status: 'cancel'});
    }
    token03 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/GetValuesByNumberField?" + qs.stringify(data),
        method: "get",
        token: token03.token,
    })
};

//获取时间类型字段的去重数据，并筛选返回时间的格式
let token04 = null;
export const GetValuesByDateField = async (data) => {
    if (token04) {
        token04.cancel({status: 'cancel'});
    }
    token04 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/GetValuesByDateField?" + qs.stringify(data),
        method: "get",
        token: token04.token,
    })
};


//获取时间类型字段的去重数据，并筛选返回时间的格式
let token05 = null;
export const GetEchartsData = async (data) => {
    if (token05) {
        token05.cancel({status: 'cancel'});
    }
    token05 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/GetEchartsData",
        method: "post",
        data: data,
        token: token05.token,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};


//获取时间类型字段的去重数据，并筛选返回时间的格式
let token13 = null;
export const GetEcharts = async (data) => {
    if (token05) {
        token05.cancel({status: 'cancel'});
    }
    token05 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/GetEcharts",
        method: "post",
        data: data,
        token: token05.token,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//上传预览图
let token06 = null;
export const UploadPreviewPictureAsync = async (data) => {
    if (token06) {
        token06.cancel({status: 'cancel'});
    }
    token06 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/UploadPreviewPictureAsync",
        method: "post",
        data: data,
        token: token06.token,
        loading:true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//验证多维分析中同一用户下是否存在相同的名称
let token07 = null;
export const GetDataViewNameVerify = async (data) => {
    if (token07) {
        token07.cancel({status: 'cancel'});
    }
    token07 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/GetDataViewNameVerify?" + qs.stringify(data),
        method: "get",
        token: token07.token,
        loading:true,
    })
};


// 保存试图集
let token08 = null;
export const SaveCharts = async (data) => {
    if (token08) {
        token08.cancel({status: 'cancel'});
    }
    token08 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/SaveCharts",
        method: "post",
        data: data,
        token: token08.token,
        loading:true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};


//根据试图集id获取详情
let token09 = null;
export const GetDataViewByID = async (data) => {
    if (token09) {
        token09.cancel({status: 'cancel'});
    }
    token09 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/GetDataViewByID?" + qs.stringify(data),
        method: "get",
        token: token09.token,
    })
};


let token10 = null;
export const UploadPreviewPictureAsyncByBase64 = async (data) => {
    if (token10) {
        token10.cancel({status: 'cancel'});
    }
    token10 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/UploadPreviewPictureAsyncByBase64",
        method: "post",
        data: data,
        token: token10.token,
        loading:true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};


//添加、修改钻取目录
let token11 = null;
export const SubDrilling = async (data) => {
    if (token11) {
        token11.cancel({status: 'cancel'});
    }
    token11 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/SubDrilling",
        method: "post",
        data: data,
        token: token11.token,
        loading:true,
        isNoQS: true,
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};

//获取下钻字段
let token12 = null;
export const GetDrillingInfo = async (data) => {
    if (token12) {
        token12.cancel({status: 'cancel'});
    }
    token12 = axios.token();
    return axios.ajax({
        url: baseUrl.xy[5] + "/GetDrillingInfo?" + qs.stringify(data),
        method: "get",
        token: token12.token,
    })
};


